import React, { useEffect, useState } from "react";
import {
    Paper,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Checkbox,
    Menu,
    MenuItem,
    Modal,
    FormControl,
} from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import styles from "./style.css";
import { Table } from "react-bootstrap";
import CustomSearchDropdown from "../../../../stylized/CustomDropDown/index";
import { useDispatch, useSelector } from "react-redux";
import {
    fetchFilterData,
    openInstance,
} from "../../../../../actions/DashboardActions";
import http from "../../../../../bae-client/HTTP";
import CustomDateDropdown from "../../../../stylized/CustomDateDropdown";
import { getParsedDateByDateAndTime } from "../../../../../bae-client/Utils";
import Loader from "../../../../stylized/Loader";
import { setActivePage, setActiveRipple } from "../../../../../actions";
import { setSnackbarAction } from "../../../../../services/services/app";
import AddDocuments from "../document-chain/modals/AddDocuments";
import AddInstance from "../document-chain/modals/AddInstance";
import DocumentViewerModal from "../../../../stylized/DocumentViewerModal";
import DocViwer from "../../../../stylized/DocViwer";
import AlertDialog from "../../../../stylized/AlertDialog";
import CustomSnackbar from "../../../../stylized/CustomSnackbar/CustomSnackbar";
import {
    setAllInstanceWithFilterAlert,
    setSelectedAlerts,
    setFinalFilter,
    setSelectedExceptionAlertIds,
    setSelectedFlowIdsAlert,
    setSelectedTimeFilterGlobalAlert,
    setSelectedFilterOptions,
} from "../../../../../actions/DocumentChainActions";
import { Box } from "@material-ui/core";
import "./style.css";
import { fetchUnreadCountOfAlerts } from "../../../../../actions/AlertActions";

const AlertLog = () => {
    const selectedFlowIdsAlert = useSelector(
        (state) => state.selectedFlowIdsAlert
    );
    const selectedTimeFilterGlobalAlert = useSelector(
        (state) => state.selectedTimeFilterGlobalAlert
    );
    const selectedExceptionIdsAlert = useSelector(
        (state) => state.selectedExceptionIdsAlert
    );
    const selectedFinalFilter = useSelector(
        (state) => state.selectedFinalFilter
    );
    const selectedAlertIds = useSelector((state) => state.selectedAlertIds);
    const allInstanceWithFilterAlert = useSelector(
        (state) => state.allInstanceWithFilterAlert
    );
    const selectedFilterOptions = useSelector(
        (state) => state.selectedFilterOptions
    );
    const dispatch = useDispatch();
    const [genericList, setGenericList] = React.useState([]);
    const [instanceList, setInstanceList] = React.useState([]);
    const [stepNameList, setStepNameList] = React.useState([]);
    const [
        selectedGenericDropdownLocalValue,
        setSelectedGenericDropdownLocalValue,
    ] = React.useState(null);
    const [
        selectedAlertTypeDropdownLocalValue,
        setSelectedAlertTypeDropdownLocalValue,
    ] = React.useState([]);
    const [
        selectedInstanceDropdownLocalValue,
        setSelectedInstanceDropdownLocalValue,
    ] = React.useState([]);
    const [
        selectedStepNamesDropdownLocalValue,
        setSelectedStepNamesDropdownLocalValue,
    ] = React.useState([]);

    const [dateErr, setDateErr] = React.useState(false);
    const [selectedTimeState, setSelectedTimeState] = React.useState({});
    const filterRawDataRedux = useSelector(
        (state) => state.DashboardDCFilterData
    );
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedAlert, setSelectedAlert] = useState(null);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(100);
    const [selected, setSelected] = React.useState([]);
    const [alertData, setAlertData] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [checkDisplay, setCheckDisplay] = useState(false);
    const [allWithFilter, setAllWithFilter] = useState([]);
    const [isDocumentAlert, setIsDocumentAlert] = React.useState(false);
    const [isDocAdditionAlert, setIsDocAdditionAlert] = React.useState(false);
    const [isRippleAlert, setIsRippleAlert] = React.useState(false);
    const [isExceptionAlert, setIsExceptionAlert] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [showDocumentModal, setShowDocumentModal] = React.useState(false);
    const [values, setValues] = React.useState(null);
    const [flowInfo, setFlowInfo] = React.useState(null);
    const [showAddInstanceModal, setShowAddInstanceModal] = useState(false);
    const [selectedGenericInstances, setSelectedGenericInstances] = useState(
        []
    );
    const [checkRead, setCheckRead] = useState(true);
    const [className, setClassName] = React.useState("headerSortDown");
    const [classCDate, setclassCDate] = React.useState("headerSortDown");
    const [selectedRow, setSelectedRow] = React.useState(null);
    const [selectedInstance, setSelectedInstance] = React.useState(null);
    const [documentIdState, setDocumentIdState] = React.useState(null);
    const [documentModalShow, setDocumentModalShow] = useState(false);
    const [currentShowFileName, setCurrentShowFileName] = useState("");
    const [currentShowFileLocation, setCurrentShowFileLocation] = useState("");
    const [showAlertDialog, setShowAlertDialog] = useState(false);
    const [alertDialogMessage, setAlertDialogMessage] = useState("");
    const setOpenDialog = (flag) => setOpenSnackMsg(flag);
    const [openSnackMsg, setOpenSnackMsg] = useState(false);
    const [message, setMessage] = useState("");
    const open = Boolean(anchorEl);
    useEffect(() => {
        if (allWithFilter.length) setAlertData(allWithFilter);
    }, [allWithFilter]);
    useEffect(() => {
        selectedFinalFilter === null
            ? loadAlerts()
            : setAlertData(selectedFinalFilter);
    }, []);
    const style = {
        position: "absolute",
        top: "59%",
        left: "53%",
        transform: "translate(-50%, -50%)",
        // width: "211px",
        height: "280px",
        // maxWidth: "432px",
        bgcolor: "background.paper",
        border: "1px solid #D7DEEA",
        boxShadow: 24,
        p: 4,
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        borderRadius: "8px",
    };

    const modalTitleStyle = {
        fontFamily: "Montserrat",
        fontSize: "20px",
        fontWeight: 500,
        lineHeight: "28px",
        letterSpacing: "-0.017em",
        textAlign: "left",
    };

    const closeButtonStyle = {
        position: "absolute",
        top: "10px",
        right: "10px",
        cursor: "pointer",
        fontSize: "24px",
    };
    const resetButtonStyle = {
        width: "83px",
        height: "36px",
        padding: "6px 16px",
        gap: "8px",
        borderRadius: "4px",
        border: "1px solid #D7DEEA",
        backgroundColor: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    };
    const applyButtonStyle = {
        width: "92px",
        height: "36px",
        padding: "6px 16px",
        gap: "8px",
        borderRadius: "4px",
        backgroundColor: "#0B5CD7",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    };

    const updateAlertData = (alerts) => {
        let finalAlertData = [];
        alerts.forEach((alert) => {
            if (alert.hasOwnProperty("exceptionLogObjectId")) {
                if (alert.status !== "CLOSED") {
                    finalAlertData.push(alert);
                }
            } else {
                if (alert.isCleared === false) {
                    finalAlertData.push(alert);
                }
            }
        });
        return finalAlertData;
    };
    const loadAlerts = (sortReset) => {
        const url = "alert/list";
        setShowLoader(true);
        http.sendRestRequest(url, "GET")
            .then((response) => {
                isSorted
                    ? sortData(
                          sortReset
                              ? "desc"
                              : orderBy === "asc"
                              ? "desc"
                              : "asc",
                          response
                      )
                    : setAlertData(response);
                setAllWithFilter(response);
                setShowLoader(false);
            })
            .catch((error) => {
                setShowLoader(false);
                console.error("Error fetching alert data: ", error);
            });
    };
    const alertTypeList = [
        {
            text: "DELAYED",
            value: "DELAYED",
            id: "DELAYED",
        },
        {
            text: "SKIPPED",
            value: "SKIPPED",
            id: "SKIPPED",
        },
        {
            text: "KEY MISSING",
            value: "KEY MISSING",
            id: "KEY MISSING",
        },
        {
            text: "KEY MISMATCH",
            value: "KEY MISMATCH",
            id: "KEY MISMATCH",
        },
        {
            text: "PROACTIVE ALERT",
            value: "PROACTIVE ALERT",
            id: "PROACTIVE ALERT",
        },
        {
            text: "DATE CHANGED",
            value: "DATE CHANGED",
            id: "DATE CHANGED",
        },
        {
            text: "RIPPLE",
            value: "RIPPLE",
            id: "RIPPLE",
        },
        {
            text: "DOCUMENT",
            value: "DOCUMENT",
            id: "DOCUMENT",
        },
        {
            text: "OTHERS",
            value: "OTHERS",
            id: "OTHERS",
        },
    ];

    useEffect(() => {
        fetchLatestFlowsData();
    }, []);
    const createGenericDropdownList = (response) => {
        let itemList = [];
        response.forEach((filterItem) => {
            itemList.push({
                text: filterItem.genericRegistry.genericDisplayName,
                value: filterItem.genericRegistry.genericDisplayName,
                id: filterItem.genericRegistry.genericId,
            });
        });
        itemList.sort((a, b) => a.text.localeCompare(b.text));

        setGenericList(itemList);
    };
    const handleOptionClick = (option) => {
        if (selectedOptions.includes(option)) {
            setSelectedOptions(selectedOptions.filter((o) => o !== option));
        } else {
            setSelectedOptions([...selectedOptions, option]);
        }
    };
    const handleOptionClickAll = () => {
        if (selectedOptions.length === 4) {
            setSelectedOptions([]);
        } else {
            setSelectedOptions(["read", "unread", "open", "closed"]);
        }
    };

    const fetchLatestFlowsData = () => {
        http.sendRestRequest("documentChain/objects")
            .then((response) => {
                dispatch(fetchFilterData(response));
                createGenericDropdownList(response);
            })
            .catch((err) => console.log(err));
    };
    const handleAlertTypeSelection = (index, selectedExceptionsValues) => {
        setSelectedAlertTypeDropdownLocalValue(selectedExceptionsValues);
    };
    const handleSelectedTimeFilterData = (data) => {
        setSelectedTimeState(data);
    };
    function getSelectedGenericIndex(selectedGeneric) {
        let genericIndex;
        filterRawDataRedux.forEach((generic, index) => {
            if (generic.genericRegistry.genericId === selectedGeneric.id) {
                genericIndex = index;
            }
        });
        return genericIndex;
    }
    const createInstanceDropdownList = (genericIndex) => {
        let instances = filterRawDataRedux[genericIndex].instances;
        let instanceList = [];
        instances.forEach((instance) => {
            instanceList.push({
                text: instance.instanceName,
                value: instance.instanceName,
                id: instance.instanceId,
            });
        });
        setInstanceList(instanceList);
    };
    const createStepNamesDropdownList = (genericIndex) => {
        let itemList = [];
        filterRawDataRedux[genericIndex]?.stepNames.forEach((item) => {
            itemList.push({
                text: item,
                value: item,
                id: item,
            });
        });
        setStepNameList(itemList);
    };
    const createData = (
        id,
        alertType,
        flow,
        instance,
        stepName,
        description,
        date,
        index,
        isFlow,
        clickAction,
        clickActionParameters,
        instanceId,
        genericId,
        isRead,
        status,
        source,
        category
    ) => {
        return {
            id,
            alertType,
            flow,
            instance,
            stepName,
            description,
            date,
            index,
            isFlow,
            clickAction,
            clickActionParameters,
            instanceId,
            genericId,
            isRead,
            status,
            source,
            category,
        };
    };
    const handleGenericSelection = (index, selectedGeneric) => {
        setSelectedGenericDropdownLocalValue(selectedGeneric);
        let genericIndex = getSelectedGenericIndex(selectedGeneric);
        createInstanceDropdownList(genericIndex);
        createStepNamesDropdownList(genericIndex);
        setSelectedInstanceDropdownLocalValue([]);
        setSelectedStepNamesDropdownLocalValue([]);
    };
    const handleInstancesSelection = (index, selectedInstances) => {
        setSelectedInstanceDropdownLocalValue(selectedInstances);
    };
    const [opens, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClosed = () => setOpen(false);
    const handleStepNameSelection = (index, selectedStepNames) => {
        setSelectedStepNamesDropdownLocalValue(selectedStepNames);
    };
    const listRows =
        alertData && Array.isArray(alertData)
            ? alertData.map((item, index) =>
                  createData(
                      item?.exceptionLogObjectId
                          ? item?.exceptionLogObjectId
                          : item.alertRegistryId,
                      item.exceptionType || item.alertType,
                      item.genericDisplayName,
                      item.instanceName,
                      item.stepName,
                      item.exceptionText || item.alertBody,
                      getParsedDateByDateAndTime(item.createdOn),
                      index,
                      item?.exceptionLogObjectId ? true : false,
                      item.clickAction,
                      item.clickActionParameters,
                      item.instanceId,
                      item.genericId,
                      item?.isRead,
                      item?.status,
                      item?.source,
                      item?.category
                  )
              )
            : [];

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = listRows.map((n) => n.id);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };
    useEffect(() => {
        setSelectedAlertTypeDropdownLocalValue(selectedAlertIds);
        setSelectedTimeState(selectedTimeFilterGlobalAlert);
        setSelectedGenericDropdownLocalValue(selectedFlowIdsAlert);
        setSelectedStepNamesDropdownLocalValue(selectedExceptionIdsAlert);
        setSelectedInstanceDropdownLocalValue(allInstanceWithFilterAlert);
        setSelectedOptions(selectedFilterOptions);
    }, [
        selectedAlertIds,
        selectedTimeFilterGlobalAlert,
        selectedFlowIdsAlert,
        selectedExceptionIdsAlert,
        allInstanceWithFilterAlert,
        selectedFilterOptions,
    ]);

    const handleReset = () => {
        setSelectedAlertTypeDropdownLocalValue([]);
        setSelectedTimeState([]);
        setSelectedGenericDropdownLocalValue([]);
        setSelectedStepNamesDropdownLocalValue([]);
        setSelectedInstanceDropdownLocalValue([]);
        setSelectedOptions([]);
        dispatch(setSelectedFlowIdsAlert(null));
        dispatch(setSelectedExceptionAlertIds(null));
        dispatch(setSelectedTimeFilterGlobalAlert(null));
        dispatch(setAllInstanceWithFilterAlert(null));
        dispatch(setSelectedAlerts(null));
        dispatch(setFinalFilter(null));
        dispatch(setSelectedFilterOptions([]));
        setOrderBy("asc");
        setIsSorted(false);
        loadAlerts("resetSort");
        setDateErr(false)
    };

    const handleClear = () => {
        const selectedAlerts = [];
        const selectedExceptions = [];
        alertData.forEach((alert, alertIndex) => {
            selected.forEach((selectedAlertIndex) => {
                if (selectedAlertIndex === alertIndex) {
                    if (alert.hasOwnProperty("alertRegistryId")) {
                        selectedAlerts.push(alert.alertRegistryId);
                    } else {
                        let obj = {
                            genericId: alert.genericId,
                            exceptionLogObjectId: alert.exceptionLogObjectId,
                            status: "CLOSED",
                        };
                        selectedExceptions.push(obj);
                    }
                }
            });
        });
        if (selectedAlerts.length || selectedExceptions.length) {
            setShowLoader(true);

            const requests = [];

            if (selectedAlerts.length) {
                const url = "alert/clear";
                requests.push(http.sendRestRequest(url, "PUT", selectedAlerts));
            }

            if (selectedExceptions.length) {
                const url = "documentChain/exception/status";
                requests.push(
                    http.sendRestRequest(url, "PUT", selectedExceptions)
                );
            }

            Promise.all(requests)
                .then(() => {
                    setOpenDialog(true);
                    setMessage("Alerts closed successfully!");
                    loadAlerts();
                    handleReset();
                    setShowLoader(false);
                    setSelected([]);
                })
                .catch((e) => {
                    console.log(e);
                    setShowLoader(false);
                });
            setShowLoader(false);
        }
    };
    const handleApplyFilter = () => {
        const stepNames = Array.isArray(selectedStepNamesDropdownLocalValue)
            ? selectedStepNamesDropdownLocalValue.map((item) => item.id)
            : [];
        let alertTypes = Array.isArray(selectedAlertTypeDropdownLocalValue)
            ? selectedAlertTypeDropdownLocalValue.map((item) => item.value)
            : [];
        const genericIds =
            selectedGenericDropdownLocalValue &&
            selectedGenericDropdownLocalValue.id;
        const instanceIds = Array.isArray(selectedInstanceDropdownLocalValue)
            ? selectedInstanceDropdownLocalValue.map((item) => item.id)
            : [];
        const startDate = selectedTimeState && selectedTimeState.startDate;
        const endDate = selectedTimeState && selectedTimeState.endDate;
        let documentTypeIndex = alertTypes.indexOf("DOCUMENT");
        if (documentTypeIndex >= 0) {
            alertTypes[documentTypeIndex] = "DOCUMENT ADDITION";
            alertTypes.push("DOCUMENT INTERSECTION");
        }
        let putPayload = {
            // includeClearedAlerts: checkDisplay,
            alertTypes: alertTypes,
            genericIds: genericIds ? [genericIds] : [],
            instanceIds: instanceIds,
            stepNames: stepNames,
        };
        if (
            startDate !== "" &&
            startDate !== null &&
            startDate !== "NaN-NaN-NaN" &&
            endDate !== "" &&
            endDate !== null &&
            endDate !== "NaN-NaN-NaN"
        ) {
            putPayload = {
                ...putPayload,
                startDate: `${startDate} 00:00:00.000`,
                endDate: `${endDate} 23:59:59.999`,
            };
        }
        if (
            selectedOptions.includes("read") &&
            !selectedOptions.includes("unread")
        ) {
            putPayload = { ...putPayload, isRead: true };
        }
        if (
            !selectedOptions.includes("read") &&
            selectedOptions.includes("unread")
        ) {
            putPayload = { ...putPayload, isRead: false };
        }
        if (
            selectedOptions.includes("open") &&
            !selectedOptions.includes("closed")
        ) {
            putPayload = { ...putPayload, status: "OPEN" };
        }
        if (
            !selectedOptions.includes("open") &&
            selectedOptions.includes("closed")
        ) {
            putPayload = { ...putPayload, status: "CLOSED" };
        }
        const url = "alert/filter";
        setShowLoader(true);
        http.sendRestRequest(url, "POST", putPayload)
            .then((response) => {
                isSorted
                    ? sortData(orderBy === "asc" ? "desc" : "asc", response)
                    : setAlertData(response);
                dispatch(
                    setSelectedFlowIdsAlert(selectedGenericDropdownLocalValue)
                );
                dispatch(
                    setSelectedExceptionAlertIds(
                        selectedStepNamesDropdownLocalValue
                    )
                );
                dispatch(setSelectedTimeFilterGlobalAlert(selectedTimeState));
                dispatch(
                    setAllInstanceWithFilterAlert(
                        selectedInstanceDropdownLocalValue
                    )
                );
                dispatch(
                    setSelectedAlerts(selectedAlertTypeDropdownLocalValue)
                );
                dispatch(setSelectedFilterOptions(selectedOptions));
                dispatch(setFinalFilter(response));
                handleClosed();
                setShowLoader(false);
            })
            .catch((error) => {
                setShowLoader(false);
                handleClosed();

                console.error("Error fetching alert data: ", error);
            });
    };

    const handleClick = (event, index, row) => {
        event.stopPropagation();
        const selectedIndex = selected.indexOf(row.id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, row.id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };

    const useStyles = makeStyles({
        root: {
            borderRadius: "4px !important",
            display: "inline-flex",
            flexDirection: "column",
            position: "relative",
            minWidth: "0px",
            padding: "0px",
            margin: "8px",
            border: "0px",
            verticalAlign: "top",
            width: "100%",
        },
        moreBtn: {
            borderRadius: "6px !important",
            display: "inline-flex",
            flexDirection: "column",
            position: "relative",
            minWidth: "0px",
            padding: "0px",
            margin: "8px",
            border: "0px",
            verticalAlign: "top",
            width: "97%",
        },
        dateRoot: {
            marginBottom: "5%",
            marginLeft: "0.5%",
        },
        compareDate: {
            marginBottom: "7%",
        },
    });
    const classes = useStyles();
    const orderByColumn = React.useRef("");
    const isSelected = (index) => selected.indexOf(index) !== -1;
    const [orderBy, setOrderBy] = React.useState("asc");
    const [isSorted, setIsSorted] = React.useState(false);
    function sortAscending(a, b) {
        if (
            a[orderByColumn.current]?.toUpperCase() <
            b[orderByColumn.current]?.toUpperCase()
        ) {
            return -1;
        }
        if (
            a[orderByColumn.current]?.toUpperCase() >
            b[orderByColumn.current]?.toUpperCase()
        ) {
            return 1;
        }
        return 0;
    }
    function sortDescending(a, b) {
        if (
            b[orderByColumn.current]?.toUpperCase() <
            a[orderByColumn.current]?.toUpperCase()
        ) {
            return -1;
        }
        if (
            b[orderByColumn.current]?.toUpperCase() >
            a[orderByColumn.current]?.toUpperCase()
        ) {
            return 1;
        }
        return 0;
    }

    const sortData = (orderBy, response) => {
        orderByColumn.current = "createdOn";
        let dataToSort = response ? response : [...alertData];
        let sortedData = dataToSort.sort(
            orderBy === "asc" ? sortAscending : sortDescending
        );
        setAlertData([]);
        setAlertData(sortedData);
    };
    const handleSorting = () => {
        setIsSorted(true);
        orderBy === "asc"
            ? setclassCDate("headerSortUp")
            : setclassCDate("headerSortDown");
        sortData(orderBy);
        orderBy === "asc" ? setOrderBy("desc") : setOrderBy("asc");
    };
    const columns = [
        { id: "alertType", label: "Alert Type", minWidth: 129 },
        // { id: "flow", label: "Flow", minWidth: 70 },
        // { id: "instance", label: "Instance", minWidth: 30 },
        // { id: "stepName", label: "Step Name", minWidth: 115 },
        { id: "status", label: "Status", minWidth: 40 },
        { id: "category", label: "Category", minWidth: 40 },
        { id: "source", label: "Source", minWidth: 159 },
        { id: "description", label: "Description", minWidth: 159 },
        { id: "date", label: "Date", minWidth: 50 },
        { id: "actions", label: "Actions", minWidth: 30 },
    ];
    const getIconSrc = (type) => {
        switch (type) {
            case "PROACTIVE ALERT":
                return "./images/delayedAlert.svg";
            case "DELAYED":
                return "./images/stepAlert.svg";
            case "SKIPPED":
                return "./images/skipped.svg";
            case "KEY MISSING":
                return "./images/delayedAlert.svg";
            case "KEY MISMATCH":
                return "./images/delayedAlert.svg";
            case "DATE CHANGED":
                return "./images/delayedAlert.svg";
            case "RIPPLE":
                return "./images/rip.svg";
            case "DOCUMENT":
                return "./images/docss.svg";
            case "OTHERS":
                return "./images/othersAlert.svg";
            default:
                return "./images/stepAlert.svg";
        }
    };
    const renderViewDocumentModal = (event) => {
        return (
            <DocViwer
                docName={currentShowFileName}
                fileLocation={currentShowFileLocation}
            ></DocViwer>
        );
    };
    const handleDocumentModalClose = () => {
        setDocumentModalShow(false);
        // setCurrentShowFileLocation("");
    };
    const addNewInstance = (name, tags, branchId, branchName) => {
        setShowLoader(true);
        setShowAddInstanceModal(false);
        let encodedFamilyTags = encodeURIComponent(tags);
        http.sendRestRequest(
            `documentChain/instance?genericId=${
                selectedRow.id
            }&instanceName=${encodeURIComponent(
                name
            )}&familyTags=${encodedFamilyTags}&branchId=${branchId}&branchName=${branchName}`,
            "POST"
        )
            .then(() => {
                dispatch(
                    setSnackbarAction({
                        open: true,
                        message: "Instance created successfully!",
                    })
                );
                http.sendRestRequest(
                    `documentChain/instance/list?genericId=${selectedRow.id}`
                )
                    .then((instanceData) => {
                        setShowLoader(false);
                        const prevInstances = [...selectedGenericInstances].map(
                            (instance) => instance.instanceId
                        );
                        setSelectedGenericInstances(instanceData);
                        const newInstance = instanceData.filter(
                            (instance) =>
                                !prevInstances.includes(instance.instanceId)
                        );
                        setSelectedInstance(newInstance[0]);
                        setShowDocumentModal(true);
                    })
                    .catch((error) => {
                        setShowLoader(false);
                        dispatch(
                            setSnackbarAction({
                                open: true,
                                message: error.error,
                                severity: "error",
                            })
                        );
                    });
                fetchLatestFlowsData();
            })
            .catch((error) => {
                setShowLoader(false);
                dispatch(
                    setSnackbarAction({
                        open: true,
                        message: error.error,
                        severity: "error",
                    })
                );
            });
    };
    const rippleAlertClickHandler = (alert) => {
        if (alert.alertType === "ripple") {
            let rippleRegistryId = parseInt(alert.clickActionParameters);
            let url = `ripple/rippleRegistry/${rippleRegistryId}`;
            http.sendRestRequest(url, "GET").then((resp) => {
                let rippleData = resp;
                rippleData["rippleId"] = resp.rippleRegistryId;
                dispatch(setActiveRipple(rippleData));

                document.getElementById("nav_Ripple").click();
            });
        }
    };
    const openAddInstanceModal = () => {
        setShowAddInstanceModal(true);
        setShowDocumentModal(false);
    };
    const closeInstance = () => {
        setShowAddInstanceModal(false);
        setShowDocumentModal(true);
    };
    const openInstancePage = () => {
        const libData = {
            genericId: selectedAlert.genericId,
            genericName: selectedAlert.flow,
            instanceIds: [selectedAlert.instanceId],
        };
        // dispatch(setActivePage("DocuChain"));
        dispatch(openInstance(libData));
        document.getElementById("nav_Flow").click();
    };
    const openFileHandler = (selectedAlert) => {
        setShowLoader(true);
        http.sendRestRequest(
            `document/documentDetail?documentId=${parseInt(
                selectedAlert.clickActionParameters
            )}`
        )
            .then((response) => {
                setShowLoader(false);
                setCurrentShowFileName(response.documentName);
                setDocumentModalShow(true);
                setCurrentShowFileLocation(response);
            })
            .catch((error) => {
                setShowLoader(false);
                setShowAlertDialog(true);
                setAlertDialogMessage(error.error);
                console.log(error);
            });
    };
    const handleClose = (e) => {
        if (e && e.target && e.target.innerText) {
            if (e.target.innerText === "Open Instance") {
                openInstancePage();
            } else if (e.target.innerText === "Open in Ripple") {
                // openInstancePage();
                rippleAlertClickHandler(selectedAlert);
            } else if (e.target.innerText === "Attach to Flow") {
                //attachToFlow();
                if (selectedAlert?.clickActionParameters) {
                    let flowName,
                        instanceName,
                        stepName = "";
                    const data =
                        selectedAlert?.clickActionParameters?.split("&&");
                    const documentId = data[0];
                    setDocumentIdState(documentId);
                    if (documentId) {
                        http.sendRestRequest("document/documentInfo", "POST", [
                            parseInt(documentId),
                        ])
                            .then((result) => {
                                const locationIds =
                                    result[0]?.locationIds?.split("\\");
                                const workspaceId = locationIds[0];
                                const spaceId = locationIds[1];
                                let folderId;
                                if (locationIds.length === 2) {
                                    folderId = 0;
                                } else {
                                    folderId =
                                        locationIds[locationIds.length - 1];
                                }

                                const value = {
                                    workSpaceId: workspaceId,
                                    spaceId,
                                    folderId:
                                        folderId === spaceId ? "0" : folderId,
                                    documentId,
                                };
                                setValues(value);
                                const flowInfo = data[1]?.split(":");
                                if (flowInfo?.length > 1)
                                    if (flowInfo[0] === "Flow") {
                                        flowName = flowInfo[1];
                                    } else if (flowInfo[0] === "Instance") {
                                        const arr = flowInfo[1].split("/");
                                        flowName = arr[0];
                                        instanceName = arr[1];
                                    } else if (flowInfo[0] === "Step") {
                                        const arr = flowInfo[1].split("/");
                                        flowName = arr[0];
                                        instanceName = arr[1];
                                        stepName = arr[arr.length - 1];
                                    }
                                setFlowInfo({
                                    flowName,
                                    instanceName,
                                    stepName,
                                });
                                setShowDocumentModal(true);
                            })
                            .catch((err) => {
                                console.error(err);
                                dispatch(
                                    setSnackbarAction({
                                        snackbarOpen: true,
                                        snackbarType: "error",
                                        snackbarMessage:
                                            err?.error ||
                                            "Something went wrong!",
                                    })
                                );
                            });
                    }
                }
            } else if (e.target.innerText === "Open File") {
                openFileHandler(selectedAlert);
            }
            handleMarkAsReadOrUnRead("read", [selectedAlert.id]);
        }

        setAnchorEl(null);
        setIsDocumentAlert(false);
        setIsRippleAlert(false);
        setIsExceptionAlert(false);
        setIsDocAdditionAlert(false);
    };
    const handleClickMenu = (event, row) => {
        if (row.alertType === "Document Intersection") {
            setIsDocumentAlert(true);
            setSelectedAlert(row);
        } else if (row.alertType === "document addition") {
            setIsDocAdditionAlert(true);
            setSelectedAlert(row);
        } else if (row.alertType === "ripple") {
            setIsRippleAlert(true);
            setSelectedAlert(row);
        } else if (row.isFlow) {
            setIsExceptionAlert(true);
            setSelectedAlert(row);
        }
        setAnchorEl(event.currentTarget);
    };

    const getCell = (column, row, value, rid, cid) => {
        let isRead = row?.isRead;
        if (column === "actions")
            return (
                <div
                    className={"cell_style"}
                    style={{
                        cursor: "pointer",
                        height: "24px",
                    }}
                    id={"menu_option_" + rid}
                    onClick={(event) => {
                        event.stopPropagation();
                        handleClickMenu(event, row);
                    }}
                >
                    <img
                        alt={"options"}
                        title="option"
                        src="./images/options.png"
                        style={{ marginLeft: "20px" }}
                    ></img>
                </div>
            );
        else if (column === "alertType") {
            let alertType =
                value.toUpperCase().split(" ")[0] === "DOCUMENT"
                    ? "DOCUMENT"
                    : value.toUpperCase();
            return (
                <div
                    className={`${styles.alertTypeCell} cell_style`}
                    style={{
                        width: "121px",
                        height: "24px",
                    }}
                    title={alertType}
                >
                    {getIconSrc(alertType) && (
                        <img
                            src={getIconSrc(alertType)}
                            alt={`${value} alert icon`}
                            style={{
                                width: "33px",
                                height: "24px",
                                paddingRight: "6px",
                            }}
                        />
                    )}
                    <span
                        className={
                            !isRead ? "checkMark cell_bold_style" : "cell_style"
                        }
                    >
                        {value.toUpperCase().split(" ")[0]}
                    </span>
                </div>
            );
        } else if (column === "Status" || column === "Category") {
            return (
                <div
                    className={`cell_style`}
                    style={{
                        width: "100px",
                        height: "24px",
                    }}
                    title={value}
                >
                    <span
                        className={
                            !isRead ? "checkMark cell_bold_style" : "cell_style"
                        }
                    >
                        {value}
                    </span>
                </div>
            );
        } else if (column === "description")
            return (
                <div
                    className={
                        !isRead
                            ? "checkMark textEllipsis cell_bold_style"
                            : "textEllipsis cell_style"
                    }
                    title={value}
                    dangerouslySetInnerHTML={{
                        __html: value,
                    }}
                    style={{
                        maxWidth: "280px",
                        height: "24px",
                    }}
                ></div>
            );
        else if (column === "source")
            return (
                <div
                    className={
                        !isRead
                            ? "checkMark textEllipsis cell_bold_style"
                            : "textEllipsis cell_style"
                    }
                    title={value}
                    style={{
                        maxWidth: "200px",
                        height: "24px",
                    }}
                >
                    {value}
                </div>
            );
        else
            return (
                <div
                    className={
                        !isRead
                            ? "checkMark textEllipsis cell_bold_style"
                            : "textEllipsis cell_style"
                    }
                    id={"flow_" + value}
                    title={value}
                    style={{
                        // width:"301px",
                        maxWidth: "135px",
                        height: "24px",
                    }}
                >
                    {value}
                </div>
            );
    };
    const handleMarkAsOpenandClosed = (type) => {
        const selectedAlerts = [];
        const selectedExceptions = [];
        alertData.forEach((alert, alertIndex) => {
            let alertId = alert?.exceptionLogObjectId
                ? alert?.exceptionLogObjectId
                : alert.alertRegistryId;
            selected.forEach((selectedId) => {
                if (selectedId === alertId) {
                    if (alert.hasOwnProperty("alertRegistryId")) {
                        selectedAlerts.push({
                            alertRegistryId: alert.alertRegistryId,
                            status: type === "OPEN" ? "OPEN" : "CLOSED",
                        });
                    } else {
                        let obj = {
                            genericId: alert.genericId,
                            exceptionLogObjectId: alert.exceptionLogObjectId,
                            status: type === "OPEN" ? "OPEN" : "CLOSED",
                        };
                        selectedExceptions.push(obj);
                    }
                }
            });
        });
        if (selectedAlerts.length || selectedExceptions.length) {
            setShowLoader(true);

            const requests = [];

            if (selectedAlerts.length) {
                const url = "alert/status";
                requests.push(http.sendRestRequest(url, "PUT", selectedAlerts));
            }

            if (selectedExceptions.length) {
                const url = "documentChain/exception/status";
                requests.push(
                    http.sendRestRequest(url, "PUT", selectedExceptions)
                );
            }

            Promise.all(requests)
                .then(() => {
                    setOpenDialog(true);
                    let status =
                        type.toLowerCase() === "open" ? "opened" : "closed";
                    setMessage(`Alert ${status} successfully!`);
                    selectedFinalFilter === null
                        ? loadAlerts()
                        : handleApplyFilter();
                    // handleReset();
                    setShowLoader(false);
                    setSelected([]);
                })
                .catch((e) => {
                    console.log(e);
                    setShowLoader(false);
                });
        }
    };
    const handleMarkAsReadOrUnRead = (type, markId) => {
        const selectedAlerts = [];
        const selectedExceptions = [];
        let selectedIds = markId ? markId : selected;
        alertData.forEach((alert, alertIndex) => {
            let alertId = alert?.exceptionLogObjectId
                ? alert?.exceptionLogObjectId
                : alert.alertRegistryId;
            selectedIds.forEach((selectedId) => {
                if (selectedId === alertId) {
                    if (alert.hasOwnProperty("alertRegistryId")) {
                        selectedAlerts.push({
                            alertRegistryId: alert.alertRegistryId,
                            isRead: type === "read" ? true : false,
                        });
                    } else {
                        let obj = {
                            genericId: alert.genericId,
                            exceptionLogObjectId: alert.exceptionLogObjectId,
                            isRead: type === "read" ? true : false,
                        };
                        selectedExceptions.push(obj);
                    }
                }
            });
        });
        if (selectedAlerts.length || selectedExceptions.length) {
            setShowLoader(true);

            const requests = [];

            if (selectedAlerts.length) {
                const url = "alert/readOrUnRead";
                requests.push(http.sendRestRequest(url, "PUT", selectedAlerts));
            }

            if (selectedExceptions.length) {
                const url = "documentChain/exception/readOrUnRead";
                requests.push(
                    http.sendRestRequest(url, "PUT", selectedExceptions)
                );
            }

            Promise.all(requests)
                .then(() => {
                    setOpenDialog(true);
                    setMessage(`Marked as ${type} successfully!`);
                    dispatch(fetchUnreadCountOfAlerts());
                    selectedFinalFilter === null
                        ? loadAlerts()
                        : handleApplyFilter();
                    setShowLoader(false);
                    setSelected([]);
                })
                .catch((e) => {
                    console.log(e);
                    setShowLoader(false);
                });
        }
    };
    const validateToApply =()=>{
        if(
            (selectedGenericDropdownLocalValue && selectedGenericDropdownLocalValue?.id) ||
            selectedStepNamesDropdownLocalValue?.length ||
            selectedAlertTypeDropdownLocalValue?.length ||
            selectedInstanceDropdownLocalValue?.length ||
           ( selectedTimeState && selectedTimeState.endDate && selectedTimeState.startDate) ||
            selectedOptions?.length 
        ) {
            if(dateErr) return dateErr
            else return false
        }
        else return true
    }
    return (
        <div className="invisibleScroller">
            <div id="dropdownContainerRow1" className={styles.alertsHeader}>
                <img src="./images/exclamation-circle.svg" alt="" />
                <span>Alerts</span>
            </div>
            <>
                {!selected.length ? (
                    <div
                        id="dropdownContainerRow1"
                        className="m-0 w-100 mb-3"
                        style={{
                            justifyContent: "space-start",
                            display: "flex",
                            flexWrap: "nowrap",
                            alignItems: "center",
                            paddingLeft: "0.8%",
                        }}
                    >
                        <CustomSearchDropdown
                            items={alertTypeList}
                            label={"Alert Type"}
                            id={"btn_select_generic"}
                            idInfo={"generic"}
                            multiSelect={true}
                            isSearchable={true}
                            isChipView={false}
                            handleSelection={handleAlertTypeSelection}
                            selection={selectedAlertTypeDropdownLocalValue}
                            customClassName={classes.root}
                            customWidth={92}
                        ></CustomSearchDropdown>
                        <CustomDateDropdown
                            setDateErr={setDateErr}
                            dateErr={dateErr}
                            setSelectedTimeFilter={handleSelectedTimeFilterData}
                            selection={selectedTimeState}
                            customClassName={"date_range_class"}
                            label={"Time"}
                            customWidth={92}
                        ></CustomDateDropdown>
                        <CustomSearchDropdown
                            items={genericList}
                            label={"Flow"}
                            id={"btn_select_generic"}
                            idInfo={"generic"}
                            multiSelect={false}
                            isSearchable={true}
                            isChipView={false}
                            handleSelection={handleGenericSelection}
                            selection={selectedGenericDropdownLocalValue}
                            customClassName={classes.root}
                            customWidth={92}
                        ></CustomSearchDropdown>
                        <CustomSearchDropdown
                            items={stepNameList}
                            label={"Step Name"}
                            id={"btn_select_generic"}
                            idInfo={"generic"}
                            multiSelect={true}
                            isSearchable={true}
                            isChipView={false}
                            handleSelection={handleStepNameSelection}
                            selection={selectedStepNamesDropdownLocalValue}
                            customClassName={classes.root}
                            customWidth={92}
                        ></CustomSearchDropdown>
                        <CustomSearchDropdown
                            items={instanceList}
                            label={"Instance"}
                            id={"btn_select_generic"}
                            idInfo={"generic"}
                            multiSelect={true}
                            isSearchable={true}
                            isChipView={false}
                            handleSelection={handleInstancesSelection}
                            selection={selectedInstanceDropdownLocalValue}
                            customClassName={classes.root}
                            customWidth={92}
                        ></CustomSearchDropdown>

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                marginLeft: "1%",
                            }}
                        >
                            <button
                                onClick={handleOpen}
                                // id="header_btn_more"
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginLeft: "1%",
                                    height: "36px",
                                    border: "1px solid #ccc",
                                    padding: "7px 5px",
                                    backgroundColor: "#fff",
                                    borderRadius: "4px",
                                }}
                            >
                                <span
                                    style={{
                                        width: "95px",
                                        // marginRight: "9px",
                                        fontFamily: "Montserrat",
                                        fontSize: "14px",
                                        fontWeight: 500,
                                        lineHeight: "24px",
                                        letterSpacing: "0.4px",
                                        textAlign: "left",
                                    }}
                                    title="More Filters"
                                >
                                    More Filters
                                </span>
                                <img src="./images/chevron-down.svg" alt="" />
                            </button>

                            <Modal
                                open={opens}
                                onClose={handleClosed}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                            >
                                <Box sx={style}>
                                    <div
                                        style={{
                                            display: "flex",
                                            gap: "6px",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            marginTop: "-12px",
                                            marginLeft: "4px",
                                        }}
                                    >
                                        {/* <div style={modalTitleStyle}>More Filters</div> */}
                                        <div
                                            style={closeButtonStyle}
                                            onClick={handleClosed}
                                        >
                                            &times;
                                        </div>
                                    </div>
                                    <FormControl className="invisibleScroller">
                                        <li
                                            key="All"
                                            onClick={() =>
                                                handleOptionClickAll()
                                            }
                                            style={{
                                                display: "flex",
                                                gap: "6px",
                                                marginBottom: "10px",
                                                cursor: "pointer",
                                                listStyleType: "none",
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={
                                                    selectedOptions.length === 4
                                                }
                                                onChange={() =>
                                                    handleOptionClickAll()
                                                }
                                                onClick={(e) =>
                                                    e.stopPropagation()
                                                }
                                                style={{ marginRight: "8px" }}
                                            />

                                            {/* <img
                                                src="./images/check-tick.svg"
                                                alt=""
                                                style={{
                                                    visibility:
                                                        selectedOptions.includes(
                                                            "All"
                                                        )
                                                            ? "visible"
                                                            : "hidden",
                                                }}
                                            /> */}
                                            <span> All</span>
                                        </li>
                                        <li
                                            key="read"
                                            onClick={() =>
                                                handleOptionClick("read")
                                            }
                                            style={{
                                                display: "flex",
                                                gap: "6px",
                                                marginBottom: "10px",
                                                cursor: "pointer",
                                                listStyleType: "none",
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={selectedOptions.includes(
                                                    "read"
                                                )}
                                                onChange={() =>
                                                    handleOptionClick("read")
                                                }
                                                onClick={(e) =>
                                                    e.stopPropagation()
                                                }
                                                style={{ marginRight: "8px" }}
                                            />
                                            {/* <img
                                                src="./images/check-tick.svg"
                                                alt=""
                                                style={{
                                                    visibility:
                                                        selectedOptions.includes(
                                                            "unread"
                                                        )
                                                            ? "visible"
                                                            : "hidden",
                                                }}
                                            /> */}
                                            read
                                        </li>
                                        <li
                                            key="unread"
                                            onClick={() =>
                                                handleOptionClick("unread")
                                            }
                                            style={{
                                                display: "flex",
                                                gap: "6px",
                                                marginBottom: "10px",
                                                cursor: "pointer",
                                                listStyleType: "none",
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={selectedOptions.includes(
                                                    "unread"
                                                )}
                                                onChange={() =>
                                                    handleOptionClick("unread")
                                                }
                                                onClick={(e) =>
                                                    e.stopPropagation()
                                                }
                                                style={{ marginRight: "8px" }}
                                            />
                                            {/* <img
                                                src="./images/check-tick.svg"
                                                alt=""
                                                style={{
                                                    visibility:
                                                        selectedOptions.includes(
                                                            "unread"
                                                        )
                                                            ? "visible"
                                                            : "hidden",
                                                }}
                                            /> */}
                                            Unread
                                        </li>
                                        <li
                                            key="open"
                                            onClick={() =>
                                                handleOptionClick("open")
                                            }
                                            style={{
                                                display: "flex",
                                                gap: "6px",
                                                marginBottom: "10px",
                                                cursor: "pointer",
                                                listStyleType: "none",
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={selectedOptions.includes(
                                                    "open"
                                                )}
                                                onChange={() =>
                                                    handleOptionClick("open")
                                                }
                                                onClick={(e) =>
                                                    e.stopPropagation()
                                                }
                                                style={{ marginRight: "8px" }}
                                            />
                                            {/* <img
                                                src="./images/check-tick.svg"
                                                alt=""
                                                style={{
                                                    visibility:
                                                        selectedOptions.includes(
                                                            "open"
                                                        )
                                                            ? "visible"
                                                            : "hidden",
                                                }}
                                            /> */}
                                            Open
                                        </li>
                                        <li
                                            key="closed"
                                            onClick={() =>
                                                handleOptionClick("closed")
                                            }
                                            style={{
                                                display: "flex",
                                                gap: "6px",
                                                marginBottom: "10px",
                                                cursor: "pointer",
                                                listStyleType: "none",
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={selectedOptions.includes(
                                                    "closed"
                                                )}
                                                onChange={() =>
                                                    handleOptionClick("closed")
                                                }
                                                onClick={(e) =>
                                                    e.stopPropagation()
                                                }
                                                style={{ marginRight: "8px" }}
                                            />
                                            {/* <img
                                                src="./images/check-tick.svg"
                                                alt=""
                                                style={{
                                                    visibility:
                                                        selectedOptions.includes(
                                                            "closed"
                                                        )
                                                            ? "visible"
                                                            : "hidden",
                                                }}
                                            /> */}
                                            Closed
                                        </li>
                                    </FormControl>
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            margin: "0px 4px",
                                            gap: "6px",
                                        }}
                                    >
                                        <button
                                            onClick={handleClosed}
                                            id="btn_reset"
                                            title="Cancel"
                                            style={resetButtonStyle}
                                        >
                                            <em>Cancel</em>
                                        </button>
                                        <button
                                            onClick={handleClosed}
                                            id="btn_apply"
                                            title="Confirm"
                                            style={applyButtonStyle}
                                        >
                                            <em>Confirm</em>
                                        </button>
                                    </div>
                                </Box>
                            </Modal>
                        </div>
                        <div
                            type="button"
                            className="btn_class"
                            title="Reset All Filters"
                            value={"Reset All Filters"}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontFamily: "Montserrat",
                                fontSize: "14px",
                                fontWeight: 500,
                                maxWidth: "200px",
                                lineHeight: "24px",
                                letterSpacing: "0.4px",
                                textAlign: "left",
                                border: "2px solid #000000",
                                color: "black",
                            }}
                            onClick={handleReset}
                        >
                            Reset All Filters
                        </div>
                        {/* <div
                            type="button"
                            className="btn_class"
                            title="Display Cleared"
                            onClick={displayClear}
                            value={"Display Cleared"}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                fontFamily: "Montserrat",
                                justifyContent: "center",
                                fontSize: "14px",
                                fontWeight: 500,
                                lineHeight: "24px",
                                letterSpacing: "0.4px",
                                textAlign: "left",
                                border: "2px solid #000000",
                                color: "black",
                            }}
                        >
                            Display Cleared
                        </div> */}
                        <div style={{ margin: "8px" }}>
                            <button
                                className={"btn share modalButton"}
                                type="button"
                                id={"btn_vie"}
                                title="Apply"
                                value={"Submit"}
                                disabled={validateToApply()}
                                onClick={() => handleApplyFilter(false)}
                            >
                                Apply
                            </button>
                        </div>
                    </div>
                ) : (
                    <div
                        id="dropdownContainerRow1"
                        className="m-0 w-100 mb-3"
                        style={{
                            justifyContent: "space-start",
                            display: "flex",
                            flexWrap: "nowrap",
                            alignItems: "center",
                            paddingLeft: "0.8%",
                        }}
                    >
                        <div
                            type="button"
                            className="btn_class"
                            title="Mark As Read"
                            value={"Mark As Read"}
                            style={{
                                width: "12%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontFamily: "Montserrat",
                                fontSize: "14px",
                                fontWeight: 500,
                                lineHeight: "24px",
                                letterSpacing: "0.4px",
                                textAlign: "left",
                                border: "2px solid #000000",
                                color: "black",
                            }}
                            onClick={() => handleMarkAsReadOrUnRead("read")}
                        >
                            Mark As Read
                        </div>
                        <div
                            type="button"
                            className="btn_class"
                            title="Mark As Unread"
                            value={"Mark As Unread"}
                            style={{
                                width: "12%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontFamily: "Montserrat",
                                fontSize: "14px",
                                fontWeight: 500,
                                lineHeight: "24px",
                                letterSpacing: "0.4px",
                                textAlign: "left",
                                border: "2px solid #000000",
                                color: "black",
                            }}
                            onClick={() => handleMarkAsReadOrUnRead("unread")}
                        >
                            Mark As Unread
                        </div>
                        <div
                            type="button"
                            className="btn_class"
                            title="Mark As Open"
                            value={"Mark As Open"}
                            style={{
                                width: "12%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontFamily: "Montserrat",
                                fontSize: "14px",
                                fontWeight: 500,
                                lineHeight: "24px",
                                letterSpacing: "0.4px",
                                textAlign: "left",
                                border: "2px solid #000000",
                                color: "black",
                            }}
                            onClick={() => handleMarkAsOpenandClosed("OPEN")}
                        >
                            Mark As Open
                        </div>
                        <div
                            type="button"
                            className="btn_class"
                            title="Mark As Closed"
                            value={"Mark As Closed"}
                            style={{
                                width: "12%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontFamily: "Montserrat",
                                fontSize: "14px",
                                fontWeight: 500,
                                lineHeight: "24px",
                                letterSpacing: "0.4px",
                                textAlign: "left",
                                border: "2px solid #000000",
                                color: "black",
                            }}
                            onClick={() => handleMarkAsOpenandClosed("CLOSED")}
                        >
                            Mark As Closed
                        </div>
                    </div>
                )}
            </>

            <Paper
                style={{ overflowX: "auto", width: "97%", marginLeft: "1.5%" }}
            >
                <TableContainer
                    id={"table_alert"}
                    className="invisibleScroller"
                >
                    {listRows && listRows.length ? (
                        <Table
                            stickyHeader
                            aria-label="sticky table"
                            style={{ width: "100%" }}
                        >
                            <TableHead
                                sx={{
                                    position: "sticky",
                                    top: "-1px",
                                    backgroundColor: "#EAEEF5",
                                    zIndex: "1",
                                }}
                            >
                                <TableRow>
                                    {<TableCell></TableCell>}
                                    <TableCell padding="checkbox">
                                        <Checkbox
                                            color="primary"
                                            indeterminate={
                                                selected.length > 0 &&
                                                selected.length <
                                                    listRows.length
                                            }
                                            checked={
                                                listRows.length > 0 &&
                                                selected.length ===
                                                    listRows.length
                                            }
                                            onChange={handleSelectAllClick}
                                            inputProps={{
                                                "aria-label":
                                                    "select all alerts",
                                            }}
                                        />
                                    </TableCell>
                                    {columns.map((column) => (
                                        <TableCell
                                            key={column.id}
                                            align={"left"}
                                            style={{
                                                minWidth: column.minWidth,
                                            }}
                                            className={
                                                column.label === "Date"
                                                    ? classCDate
                                                    : null
                                            }
                                            onClick={
                                                column.label === "Date"
                                                    ? handleSorting
                                                    : null
                                            }
                                        >
                                            {column.label}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {listRows
                                    .slice(
                                        page * rowsPerPage,
                                        page * rowsPerPage + rowsPerPage
                                    )
                                    .map((row, rid) => {
                                        const isItemSelected = isSelected(
                                            row.id
                                        );
                                        const labelId = `enhanced-table-checkbox-${rid}`;
                                        return (
                                            <>
                                                <TableRow
                                                    hover
                                                    sx={{ height: "56px" }}
                                                    role="checkbox"
                                                    aria-checked={
                                                        isItemSelected
                                                    }
                                                    tabIndex={-1}
                                                    style={
                                                        !row?.isRead
                                                            ? {
                                                                  cursor: "pointer",
                                                              }
                                                            : null
                                                    }
                                                    onClick={
                                                        !row?.isRead
                                                            ? () =>
                                                                  handleMarkAsReadOrUnRead(
                                                                      "read",
                                                                      [row.id]
                                                                  )
                                                            : null
                                                    }
                                                    key={row.index}
                                                    selected={isItemSelected}
                                                >
                                                    {!row?.isRead ? (
                                                        <TableCell
                                                            style={{
                                                                padding: "0px",
                                                                width: "1px",
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    width: "12px",
                                                                    height: "65px",
                                                                    padding:
                                                                        "0px",

                                                                    background:
                                                                        "#0B5CD7",
                                                                }}
                                                            ></div>
                                                        </TableCell>
                                                    ) : (
                                                        <TableCell
                                                            style={{
                                                                padding: "0px",
                                                                width: "1px",
                                                            }}
                                                        ></TableCell>
                                                    )}
                                                    <TableCell
                                                        padding="checkbox"
                                                        onClick={(event) =>
                                                            handleClick(
                                                                event,
                                                                row.index,
                                                                row
                                                            )
                                                        }
                                                        sx={{
                                                            height: "56px",
                                                            lineHeight: "1",
                                                        }}
                                                    >
                                                        <Checkbox
                                                            checked={
                                                                isItemSelected
                                                            }
                                                            inputProps={{
                                                                "aria-labelledby":
                                                                    labelId,
                                                            }}
                                                        />
                                                    </TableCell>
                                                    {columns.map((column) => {
                                                        const value =
                                                            row[column.id];
                                                        const cellId = `cell-${rid}-${column.id}`;
                                                        return (
                                                            <TableCell
                                                                sx={{
                                                                    height: "56px",
                                                                    lineHeight:
                                                                        "1",
                                                                }}
                                                                key={column.id}
                                                                align={"left"}
                                                                id={cellId}
                                                            >
                                                                {getCell(
                                                                    column.id,
                                                                    row,
                                                                    value,
                                                                    rid,
                                                                    cellId
                                                                )}
                                                            </TableCell>
                                                        );
                                                    })}
                                                </TableRow>
                                            </>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                    ) : (
                        <div style={{ textAlign: "center", padding: "12%" }}>
                            No Results Found.
                        </div>
                    )}
                </TableContainer>
                {isDocumentAlert ? (
                    <Menu
                        id="demo-customized-menu"
                        MenuListProps={{
                            "aria-labelledby": "demo-customized-button",
                        }}
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                    >
                        <MenuItem onClick={handleClose}>
                            <div>
                                {/* <img
                                className="deleteIcon"
                                title="Attach to Flow"
                                src="./images/Rename.svg"
                                alt="Attach to Flow"
                            /> */}
                                <span
                                    className="btn_title"
                                    title="Attach to Flow"
                                >
                                    Attach to Flow
                                </span>
                            </div>
                        </MenuItem>
                    </Menu>
                ) : null}
                {isDocAdditionAlert ? (
                    <Menu
                        id="demo-customized-menu"
                        MenuListProps={{
                            "aria-labelledby": "demo-customized-button",
                        }}
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                    >
                        <MenuItem onClick={handleClose}>
                            <div>
                                {/* <img
                                    className="deleteIcon"
                                    title="Attach to Flow"
                                    src="./images/Rename.svg"
                                    alt="Attach to Flow"
                                /> */}
                                <span className="btn_title" title="Open File">
                                    Open File
                                </span>
                            </div>
                        </MenuItem>
                    </Menu>
                ) : null}
                {isRippleAlert ? (
                    <Menu
                        id="demo-customized-menu"
                        MenuListProps={{
                            "aria-labelledby": "demo-customized-button",
                        }}
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                    >
                        <MenuItem onClick={handleClose}>
                            <div>
                                {/* <img
                                className="deleteIcon"
                                title="Attach to Flow"
                                src="./images/Rename.svg"
                                alt="Attach to Flow"
                            /> */}
                                <span
                                    className="btn_title"
                                    title="Open in Ripple"
                                >
                                    Open in Ripple
                                </span>
                            </div>
                        </MenuItem>
                    </Menu>
                ) : null}
                {isExceptionAlert ? (
                    <Menu
                        id="demo-customized-menu"
                        MenuListProps={{
                            "aria-labelledby": "demo-customized-button",
                        }}
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                    >
                        <MenuItem onClick={handleClose}>
                            <div>
                                {/* <img
                                className="deleteIcon"
                                title="Attach to Flow"
                                src="./images/Rename.svg"
                                alt="Attach to Flow"
                            /> */}
                                <span
                                    className="btn_title"
                                    title="Open Instance"
                                >
                                    Open Instance
                                </span>
                            </div>
                        </MenuItem>
                    </Menu>
                ) : null}
                {showDocumentModal ? (
                    <AddDocuments
                        documentId={documentIdState}
                        setSelectedRow={setSelectedRow}
                        openAddInstanceModal={openAddInstanceModal}
                        values={values}
                        folderId={values?.folderId}
                        showDocumentModal={showDocumentModal}
                        closeModal={() => setShowDocumentModal(false)}
                        // flowInfo={flowInfo}
                        // documentCloseAlert={documentCloseAlert}
                        // flowInfo={{
                        //     flowName: "21 st march",
                        //     instanceName: "Instance 1",
                        //     stepName: "",
                        // }}
                    />
                ) : null}
                {showAddInstanceModal ? (
                    <AddInstance
                        selectedGenericInstances={selectedGenericInstances}
                        selectedInstance={selectedInstance}
                        showAddInstanceModal={showAddInstanceModal}
                        closeModal={closeInstance}
                        currentFamilyTags={[]}
                        currentInstanceName={""}
                        heading={"Add New Instance"}
                        branchsId={"1"}
                        branchsName={"1"}
                        disabled={false}
                        editNewInstance={""}
                        addNewInstance={addNewInstance}
                    ></AddInstance>
                ) : null}
                <DocumentViewerModal
                    showHeader={true}
                    footer="false"
                    show={documentModalShow}
                    size="lg"
                    onHide={handleDocumentModalClose}
                    title={currentShowFileName}
                    modalBodyClass="documentViewModal"
                    onclick={() => {}}
                    submitButtonText="Close"
                    headerTitle={currentShowFileName}
                    // fileSource={currentShowFileLocation}
                >
                    {documentModalShow ? renderViewDocumentModal() : null}
                </DocumentViewerModal>
                <TablePagination
                    rowsPerPageOptions={[50, 100, 150]}
                    component="div"
                    count={listRows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
            <AlertDialog
                open={showAlertDialog}
                message={alertDialogMessage}
                setOpen={setShowAlertDialog}
                title={""}
                isAlert={false}
            ></AlertDialog>
            <CustomSnackbar
                open={openSnackMsg}
                setOpen={setOpenDialog}
                alertMessage={message}
            ></CustomSnackbar>
            <Loader show={showLoader}></Loader>
        </div>
    );
};

export default AlertLog;
